module.exports = __webpack_public_path__ + "miscusi-static/fonts/icomoon.6311fa023fd70921298f1a51d8f442d1.woff";